import React, { Fragment, useContext, useEffect, useState } from 'react';
import ErrorBoundary from '../ErrorBoundary';
import { connect } from 'react-redux';
import { Badge, Button, Dropdown, Modal, Table } from 'react-bootstrap';
import Editor from '@jsx/components/RichTextEditor';
import { AdminActions } from '@adapters/redux/reducer/admin';
import PageLoader from '../Loader/PageLoader';
import Swal from 'sweetalert2';
import { ToastNotificationContext } from '@context/ToastNotificationContext';
import { fullBackendPath } from 'core/helpers';
import { ICON_MORE } from '@services/constant';

const Page = (props) => {
  const { notifySuccess, notifyError } = useContext(ToastNotificationContext);
  const { experiences, updateData, deleteData, updating } = props;

  const [showModal, setShowModal] = useState(false);
  const [showModalDetail, setShowModalDetail] = useState(false);

  const [modalType, setModalType] = useState('create');
  const [itemUpdate, setItemUpdate] = useState();
  const [name, setName] = useState('');
  const [nameVie, setNameVie] = useState('');
  const [describe, setDescribe] = useState('');
  const [describeVie, setDescribeVie] = useState('');
  const [shortDescribe, setShortDescribe] = useState('');
  const [shortDescribeVie, setShortDescribeVie] = useState('');
  const [background, setBackground] = useState(null);

  useEffect(() => {
    if (!showModal) {
      setItemUpdate(null);
      setName('');
      setNameVie('');
      setDescribe('');
      setDescribeVie('');
      setShortDescribe('');
      setShortDescribeVie('');
      setBackground(null);
    }
  }, [showModal]);

  const onClickShowModalCreate = () => {
    setModalType('create');
    setName('');
    setDescribe('');
    setShortDescribe('');
    setNameVie('');
    setDescribeVie('');
    setShortDescribeVie('');
    setBackground(null);
    setShowModal(true);
  };

  const onClickShowModalEdit = (item, isEdit = true) => {
    const {
      name,
      describe,
      short_describe,
      name_vi,
      describe_vi,
      short_describe_vi,
    } = item;

    isEdit && setModalType('edit');
    setItemUpdate(item);
    setName(name);
    setDescribe(describe);
    setShortDescribe(short_describe);
    setNameVie(name_vi);
    setDescribeVie(describe_vi);
    setShortDescribeVie(short_describe_vi);
    setBackground(null);
    isEdit ? setShowModal(true) : setShowModalDetail(true);
  };

  const onClickDelete = (item) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      confirmButtonColor: 'red',
      position: 'top',
      customClass: 'margin-top-20',
      reverseButtons: true,
    }).then(({ value }) => {
      if (value) {
        deleteData(
          item.id,
          `experience/${item.id}`,
          'experiences',
          (isError, error) => {
            if (isError) {
              notifyError(error);
            } else {
              notifySuccess('Delete successfully');
            }
          }
        );
      }
    });
  };

  const onSubmit = () => {
    const method = modalType === 'create' ? 'post' : 'put';
    const url =
      modalType === 'create' ? 'experience' : `experience/${itemUpdate.id}`;

    const params = {
      name,
      name_vi: nameVie,
      describe,
      describe_vi: describeVie,
      short_describe: shortDescribe,
      short_describe_vi: shortDescribeVie,
      images: [],
    };

    if (background)
      params.images.push({
        field: 'experience_background',
        image: background,
      });

    updateData(method, url, params, 'experiences', (isError, error) => {
      if (isError) {
        notifyError(error);
      } else {
        setShowModal(false);
        notifySuccess(
          method === 'post' ? 'Create successfully' : 'Update successfully'
        );
      }
    });
  };

  return (
    <Fragment>
      <div className="text-right mb-3">
        <button onClick={onClickShowModalCreate} className="btn btn-success">
          Create
        </button>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">List Experiences</h4>
            </div>
            <div className="card-body position-relative">
              {updating && !showModal && <PageLoader />}
              <Table responsive>
                <thead>
                  <tr>
                    <th className="width80">
                      <strong>#</strong>
                    </th>
                    <th>
                      <strong>Title</strong>
                    </th>
                    {/* <th>
                      <strong>Short describe</strong>
                    </th> */}
                    <th>
                      <strong>Image</strong>
                    </th>
                    <th className="action-column">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {experiences?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td
                          className="cursor-pointer"
                          onClick={() => onClickShowModalEdit(item, false)}
                        >
                          {index + 1}
                        </td>
                        <td
                          className="cursor-pointer"
                          onClick={() => onClickShowModalEdit(item, false)}
                        >
                          {item.name}
                        </td>
                        {/* <td
                          className="cursor-pointer"
                          onClick={() => onClickShowModalEdit(item, false)}
                        >
                          {item.short_describe}
                        </td> */}
                        <td
                          className="cursor-pointer"
                          onClick={() => onClickShowModalEdit(item, false)}
                          style={{ width: '30%' }}
                        >
                          {item.experience_background?.path && (
                            <img
                              width={'100%'}
                              height={200}
                              style={{ objectFit: 'contain' }}
                              src={fullBackendPath(
                                item.experience_background.path
                              )}
                            />
                          )}
                        </td>
                        <td className="action-column">
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="success"
                              className="light sharp i-false"
                            >
                              {ICON_MORE}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => onClickShowModalEdit(item)}
                              >
                                Edit
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => onClickDelete(item)}
                              >
                                Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
      <Modal className="fade" enforceFocus={false} show={showModal} size="lg">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit();
          }}
        >
          <Modal.Header>
            <Modal.Title>
              {modalType === 'create' ? 'Create' : 'Edit'}
            </Modal.Title>
            <Button
              variant=""
              className="btn-close"
              onClick={() => setShowModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            {updating && <PageLoader />}
            <div className="form-group">
              <label className="form-label">Title (ENG)</label>
              <input
                className="form-control"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="form-group mt-3">
              <label className="form-label">Title (VIE)</label>
              <input
                className="form-control"
                type="text"
                value={nameVie}
                onChange={(e) => setNameVie(e.target.value)}
              />
            </div>
            {/* <div className="form-group mt-3">
              <label className="form-label">Short describe (ENG)</label>
              <input
                className="form-control"
                type="text"
                value={shortDescribe}
                onChange={(e) => setShortDescribe(e.target.value)}
              />
            </div>
            <div className="form-group mt-3">
              <label className="form-label">Short describe (VIE)</label>
              <input
                className="form-control"
                type="text"
                value={shortDescribeVie}
                onChange={(e) => setShortDescribeVie(e.target.value)}
              />
            </div> */}
            <div className="form-group mt-3">
              <label className="form-label">Describe (ENG)</label>
              <Editor value={describe} onChange={setDescribe} />
            </div>
            <div className="form-group mt-3">
              <label className="form-label">Describe (VIE)</label>
              <Editor value={describeVie} onChange={setDescribeVie} />
            </div>
            <div className="form-group mt-3">
              <label className="form-label">Background image</label>
              <input
                className="form-control"
                type="file"
                accept="image/png, image/jpeg"
                onChange={(e) => setBackground(e.target.files[0])}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger light" onClick={() => setShowModal(false)}>
              Close
            </Button>
            <Button variant="" type="submit" className="btn btn-primary">
              {modalType === 'create' ? 'Create' : 'Update'}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
      <Modal
        className="fade"
        enforceFocus={false}
        show={showModalDetail}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>Detail</Modal.Title>
          <Button
            variant=""
            className="btn-close"
            onClick={() => setShowModalDetail(false)}
          ></Button>
        </Modal.Header>
        <Modal.Body>
          {updating && <PageLoader />}
          <div className="form-group">
            <label className="form-label">Title (ENG)</label>
            <input className="form-control" type="text" value={name} disabled />
          </div>
          <div className="form-group mt-3">
            <label className="form-label">Title (VIE)</label>
            <input
              className="form-control"
              type="text"
              value={nameVie}
              disabled
            />
          </div>
          {/* <div className="form-group mt-3">
            <label className="form-label">Short describe (ENG)</label>
            <input
              className="form-control"
              type="text"
              value={shortDescribe}
              disabled
            />
          </div>
          <div className="form-group mt-3">
            <label className="form-label">Short describe (VIE)</label>
            <input
              className="form-control"
              type="text"
              value={shortDescribeVie}
              disabled
            />
          </div> */}
          <div className="form-group mt-3">
            <label className="form-label">Describe (ENG)</label>
            <Editor value={describe} disabled />
          </div>
          <div className="form-group mt-3">
            <label className="form-label">Describe (VIE)</label>
            <Editor value={describeVie} disabled />
          </div>
          <div className="form-group mt-3">
            <label className="form-label">Background image</label>
            {itemUpdate?.experience_background?.path && (
              <img
                className="img-responsive"
                width={'100%'}
                src={fullBackendPath(itemUpdate?.experience_background?.path)}
              />
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger light"
            onClick={() => setShowModalDetail(false)}
          >
            Close
          </Button>
          <Button
            variant=""
            type="button"
            className="btn btn-primary"
            onClick={() => {
              setShowModalDetail(false);
              onClickShowModalEdit(itemUpdate);
            }}
          >
            Edit
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  experiences: state.admin.experiences,
  updating: state.admin.updating,
});

const mapDispatchToProps = (dispatch) => ({
  updateData: (method, url, params, field, callback) =>
    dispatch(AdminActions.updateData(method, url, params, field, callback)),
  deleteData: (id, url, field, callback) =>
    dispatch(AdminActions.deleteData(id, url, field, callback)),
});

const withErrorBoundary = (props) => (
  <ErrorBoundary>
    <Page {...props} />
  </ErrorBoundary>
);

export default connect(mapStateToProps, mapDispatchToProps)(withErrorBoundary);
